import React, { Component } from "react";
import { Helmet } from "react-helmet";
import Dropzone from "react-dropzone";
import Menu from "./menu";
import axios, { post } from "axios";

import ReactGA from "react-ga";
ReactGA.initialize("UA-9378745-5");
ReactGA.pageview(window.location.pathname + window.location.search);

export class Wrapper extends Component {
  render() {
    return <div id="wrapper">{this.props.children}</div>;
  }
}
export class Container extends Component {
  state = {
    fileName: false,
    file: false,
    isuploading: false,
    minutes: 0,
    msg: ""
  };
  async sendReporte() {
    this.setState({
      isuploading: true
    });
    //const url = "http://localhost/compromisos/postReporte";
    const url = "https://pajaropolitico.com/apis/compromisos/postReporte";
    const formData = new FormData();
    formData.append("file", this.state.file, this.state.file.name);
    formData.append("apikey", "ZIGECG3JFB");
    formData.append("email", this.state.email);
    formData.append("msg", this.state.msg);
    formData.append(
      "compromiso",
      document.getElementById("current-compromiso").value
    );
    const config = {
      headers: {
        "content-type": "multipart/form-data"
      }
    };
    var p = await axios.post(url, formData, config);
    console.log("respuesta", p);
    this.setState({
      file: false,
      fileName: false,
      isuploading: false,
      email: "",
      msg: ""
    });
    alert("Gracias, recibimos tu reporte.");

    document.body.classList.remove("showreport");
  }
  handleDropzone(e) {
    this.setState({
      file: e[0],
      fileName: e[0].name
    });
  }
  handleTextarea(e) {
    this.setState({
      msg: e.target.value
    });
  }
  render() {
    var classes = [...this.props.classes, "container"];
    var buttonc = ["report-t-button"];
    if (!this.state.msg) {
      buttonc.push("disabled");
    }
    if (this.state.isuploading) {
      buttonc.push("uploading");
    }
    return (
      <div className={classes.join(" ")}>
        <Helmet>
          <title>
            {(this.props.contentTitle ? this.props.contentTitle + " | " : "") +
              "Peña Nieto Firmó. ¿Cumplió?"}
          </title>
        </Helmet>

        <div id="report-lightbox">
          <div className="report-lightbox-binder">
            <div id="report-lightbox-title" />
            <div className="report-t-binder">
              <input
                type="email"
                placeholder="Correo electrónico (opcional)"
                onChange={e => this.setState({ email: e.target.value })}
                value={this.state.email}
              />
            </div>
            <div className="report-t-binder">
              <textarea
                placeholder="¿Qué quieres reportar acerca de este compromiso?*"
                onChange={e => this.handleTextarea(e)}
                value={this.state.msg}
              />
            </div>
            <div className="report-t-binder" id="file-upload">
              <Dropzone
                onDrop={e => this.handleDropzone(e)}
                id="file-upload-native"
              >
                <div className="fileupload-button">
                  {this.state.fileName
                    ? this.state.fileName
                    : "Adjunta un archivo"}
                </div>
              </Dropzone>
            </div>
            <div className="report-t-disclaimer">
              *Tu reporte es completamente anónimo, solo recibiremos los datos
              de este formulario. Formatos válidos: JPG, PNG, GIF, SVG, PDF,
              DOC, DOCX, PPT. Máximo 20mb.
            </div>
            <div
              className={buttonc.join(" ")}
              onClick={() => this.sendReporte()}
            >
              {this.state.isuploading ? (
                <div className="loading-animation">
                  <div className="circleanimation">
                    <img src={require("../img/mono.svg")} />
                  </div>
                  <div className="loading-wait">
                    Subiendo reporte. Puede tomar hasta cinco minutos.
                  </div>
                </div>
              ) : (
                <span>Enviar</span>
              )}
            </div>
          </div>
          <div
            id="report-close"
            onClick={() => document.body.classList.remove("showreport")}
          />
        </div>

        {this.props.children}
      </div>
    );
  }
}
Container.defaultProps = {
  contentTitle: "",
  classes: []
};

export class Section extends Component {
  state = {
    width: 0,
    height: 0
  };
  constructor(props) {
    super(props);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }
  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }
  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }
  render() {
    return (
      <section
        ref={this.props.innerRef}
        {...this.props}
        style={this.props.full ? { height: this.state.height } : {}}
      >
        {this.props.children}
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/containers.js